import React from 'react';
import {
    Form,
    ControlLabel,
    FormGroup,
    FormControl,
    Row,
    Col
} from 'react-bootstrap'
import Axios from 'axios'
import { VARCHAR_50, VARCHAR_255, VARCHAR_100 } from '../../utils/numberConstants';

class ClubRegistrationSecondStep extends React.Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.adminUserCode = '';
        this.adminEmail = '';
        this.adminPhoneNumber = '';
        this.adminName = '';
        this.adminFirstName = '';
        this.adminUserSystemId = '';
        this.adminLanguage = { id: 0 };
        this.setDefaultValues = this.setDefaultValues.bind(this);
        this.emailValidity = false;
        this.checkEmailFieldValidity = this.checkEmailFieldValidity.bind(this)
        this.setDataOnModel = this.setDataOnModel.bind(this);
        this.ResourceServerBaseUrl = '';
        this.unDisableFieldAndCheckUserId = this.unDisableFieldAndCheckUserId.bind(this);
        this.checkUserNameIfExist = this.checkUserNameIfExist.bind(this);
    }
    componentDidMount() {
        this.props.onRef(this);
        this.setDefaultValues();
        this.checkEmailFieldValidity();
        this.ResourceServerBaseUrl = localStorage.getItem('ResourceServerBaseUrl')
        this.adminFirstNameRef.disabled = true
        this.adminUserSystemIdRef.disabled = true
        this.adminEmailRef.disabled = true
     
    }
    setDefaultValues() {
        this.adminUserCode = this.props.clubRegistrationModel.adminUserCode;
        this.adminEmail = this.props.clubRegistrationModel.adminEmail;
        this.adminPhoneNumber = this.props.clubRegistrationModel.adminPhoneNumber;
        this.adminName = this.props.clubRegistrationModel.adminName;
        this.adminFirstName = this.props.clubRegistrationModel.adminFirstName;
        this.adminLanguage = {
            id: this.props.clubRegistrationModel['adminLanguage.id'],
            name: this.props.clubRegistrationModel['adminLanguage.name']
        };
        this.adminUserSystemId = this.props.clubRegistrationModel.adminUserSystemId
        this.forceUpdate()
    }
    handleChange(e) {
        const field = e.target;
        const name = field.name;
        const type = field.type;
        const value = field.value;
        if (type === 'text') {
            // if (name !== 'adminUserCode') {
                this[name] = value;
            // }
           
            this.unDisableFieldAndCheckUserId(name,value)
        } else if (type === 'select-one') {
            this[name] = { id: Number(value), name: field.selectedOptions[0].label };

        } else if (type === 'email') {
            if (field.validity.valid) {
                this.emailValidity = true;
                this[name] = value;
                // this.adminNameRef.disabled = value !== '' ? false : true
        
                if (field.classList.contains('requiredField')) {
                    field.classList.remove('requiredField')
                    
                }
                
            } else {
           
                this.emailValidity = false;
                field.classList.add('requiredField')
            }

                 
            }
        }

   
    onSubmit(model) {
        this.setDataOnModel(model)
        let fileds = [this.adminUserCode, this.adminEmail, this.adminPhoneNumber, this.adminName, this.adminFirstName, this.adminLanguage.id,this.adminUserSystemId];
        let isValid = model.isValid(fileds);
        return isValid && this.checkEmailFieldValidity();
    }

    setDataOnModel(model) {
        model.setUserData(this.adminUserCode, this.adminEmail, this.adminPhoneNumber, this.adminName, this.adminFirstName, this.adminLanguage.id, this.adminLanguage.name, this.adminUserSystemId);
    }
    checkEmailFieldValidity() {
        if (document.forms['secondStageForm']['adminEmail'].value !== '' && document.forms['secondStageForm']['adminEmail'].validity.valid) {

            this.emailValidity = true;
            return true
        } else {

            this.emailValidity = false;
            return false
        }
    }

    unDisableFieldAndCheckUserId (inputName,fieldValue) {
     
      if(inputName === 'adminName'){
        
        if(fieldValue !== "" && inputName === 'adminName' ){
            this.adminFirstNameRef.disabled = false
        }else{
            this.adminFirstNameRef.disabled = true
        }

      }else if (inputName === 'adminPhoneNumber'){
        if(fieldValue !== "" && inputName === 'adminPhoneNumber' &&  this.adminUserSystemIdRef.value !== ""){
            this.adminLanguageRef.disabled = false
        }else {
            this.adminLanguageRef.disabled = true
        }
      }
        

       
    }

    checkUserNameIfExist (){
      
        let adminName = this.adminNameRef.value;
        let adminFirstName = this.adminFirstNameRef.value;

        let mergedName = ''

        if(this.adminUserSystemId !== ""){
            mergedName = this.adminUserSystemId
        }else {
            mergedName = `${adminName}.${adminFirstName}`
        }


       
        Axios({
            method: 'POST',
            url: this.ResourceServerBaseUrl + '/public/registerClub/existUser.do',
            params: {
                userCode: mergedName
            }
        }).then((res) => {
           if(res.data === false){
            this.adminUserSystemIdRef.disabled = false
            this.adminEmailRef.disabled = false
            this.adminUserSystemIdRef.value = mergedName
            this.adminUserSystemId = mergedName
            this.adminUserCode = mergedName
            
           
           }else{
           
                this.props.showUserExistsAlert(this.props.composingLabel('sportOauthLabel.userExists', 'User already exists', true))
                this.adminUserSystemIdRef.disabled = false
                this.adminEmailRef.disabled = true
               
           }
        }).catch(error => {
          
            this.props.showUserExistsAlert(this.props.composingLabel('userFavoriteUpdate.title', 'Gre�ka', true))
        })
    }

    render() {
        let { composingLabel } = this.props;
        return (
            <Form name='secondStageForm'>
                <fieldset className='registrationFieldSet registrationFieldSetSecondStep'>
                    <legend className="registerFieldsetLabel">{composingLabel('sportOauthLabel.userCode', 'User code')}</legend>

                    <Row className="show-grid hidden">
                        <Col className='registerFormGroupCol' lg={0} md={0} sm={0} xs={0}>
                            <FormGroup className='registerFormGroup' controlId="userCodeText">
                                <Col className='registerFieldLabel' componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12}>{composingLabel('sportOauthLabel.userCode', 'User code', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl
                                        className='registerField hidden'
                                        type="text"
                                        maxlength={VARCHAR_50}
                                        name='adminUserCode'
                                        defaultValue={this.adminUserCode}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row className="show-grid">
                        <Col className='registerFormGroupCol' lg={4} md={6} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="adminNameText">
                                <Col className='registerFieldLabel' componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12}>{composingLabel('sportOauthLabel.name', 'Name', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl
                                        className='registerField'
                                        type="text"
                                        maxlength={VARCHAR_100}
                                        name='adminName'
                                        defaultValue={this.adminName}
                                        inputRef={adminNameRef => this.adminNameRef = adminNameRef}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col className='registerFormGroupCol' lg={4} md={6} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="adminEmailText">
                                <Col className='registerFieldLabel' componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12}>{composingLabel('sportOauthLabel.emailAddress','eMail Address', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl
                                        className='registerField'
                                        type="email"
                                        name='adminEmail'
                                        maxlength={VARCHAR_255}
                                        defaultValue={this.adminEmail}
                                        inputRef={adminEmailRef => this.adminEmailRef = adminEmailRef}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                        
                    </Row>

                    <Row className="show-grid">
                        <Col className='registerFormGroupCol' lg={4} md={6} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId='adminFirstNameSelect'>
                                <Col className='registerFieldLabel' componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12}>{composingLabel('sportOauthLabel.firstName', 'First name', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl
                                        className='registerField'
                                        type="text"
                                        name='adminFirstName'
                                        maxlength={VARCHAR_100}
                                        defaultValue={this.adminFirstName}
                                        onBlur={this.checkUserNameIfExist}
                                        inputRef={adminFirstNameRef => this.adminFirstNameRef = adminFirstNameRef}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                        
                        <Col className='registerFormGroupCol' lg={4} md={6} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId='adminPhoneNumberSelect'>
                                <Col className='registerFieldLabel' componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12}>{composingLabel('sportOauthLabel.phoneNum', 'Phone number', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl
                                        className='registerField'
                                        type="text"
                                        name='adminPhoneNumber'
                                        maxlength={VARCHAR_50}
                                        inputRef={adminPhoneNumberRef => this.adminPhoneNumberRef = adminPhoneNumberRef}
                                        defaultValue={this.adminPhoneNumber}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>

                        <Col className='registerFormGroupCol' lg={4} md={6} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="adminLanguageSelect">
                                <Col className='registerFieldLabel' componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12}>{composingLabel('sportOauthLabel.userLang', 'User language', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl
                                        className='registerField'
                                        componentClass="select"
                                        name='adminLanguage'
                                        defaultValue={this.adminLanguage}
                                        inputRef={adminLanguageRef => this.adminLanguageRef = adminLanguageRef}
                                        onChange={this.handleChange} >
                                        <option value={this.adminLanguage.id}>{this.adminLanguage.name ? this.adminLanguage.name : ''}</option>
                                        {this.props.languages.map(language => {
                                            return <option key={language.id} value={language.id}>{language.name}</option>
                                        })}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row className="show-grid">
                        <Col className='registerFormGroupCol' lg={4} md={6} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId='adminFirstNameSelect'>
                                <Col className='registerFieldLabel' componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12}>{composingLabel('sportOauthLabel.UserSystemId', 'UserSystemId', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl
                                        className='registerField'
                                        type="text"
                                        name='adminUserSystemId'
                                        maxlength={VARCHAR_100}
                                        inputRef={adminUserSystemIdRef => this.adminUserSystemIdRef = adminUserSystemIdRef}
                                        defaultValue={this.adminUserSystemId}
                                        onBlur={() => this.adminEmailRef.disabled === true && this.checkUserNameIfExist()}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                </fieldset>
            </Form>
        )
    }
}

export default ClubRegistrationSecondStep;


// WEBPACK FOOTER //
// ./src/main/resources/js/components/RegistrationFormComponents/ClubRegistrationSecondStep.js